import * as React from "react";
import Img from "gatsby-image";

import { Wrapper, Track, ImageWrapper, DotsContainer, Dot } from "./style";

interface Props {
  images: any[];
}

interface State {
  active: number;
}

export default class Slider extends React.PureComponent<Props, State> {
  state = {
    active: 0
  };

  interval: number;

  componentDidMount() {
    this.interval = window.setInterval(() => this.change(), 3000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  change = () => {
    const { images } = this.props;
    this.setState(prevState => ({
      active: images[prevState.active + 1] ? prevState.active + 1 : 0
    }));
  };

  changeFromDot = (active: number) => {
    clearInterval(this.interval);
    this.setState({ active });
    this.interval = window.setInterval(() => this.change(), 3000);
  };

  render() {
    const { images } = this.props;
    const { active } = this.state;
    return (
      <Wrapper>
        <Track slidesCount={images.length} currentSlide={active}>
          {images.map(image => (
            <ImageWrapper key={image.id}>
              <Img fluid={image.fluid} />
            </ImageWrapper>
          ))}
        </Track>
        <DotsContainer>
          {images.map(({ id }, i) => (
            <Dot
              key={id}
              active={i === active}
              onClick={() => this.changeFromDot(i)}
            />
          ))}
        </DotsContainer>
      </Wrapper>
    );
  }
}
